<template>
  <a href="javascript:void" class="btn btn-sm btn-dual ml-auto" v-on:click="showcart">
    <i class="fas fa-shopping-basket"></i>
    {{ !$_.isEmpty(cart) ? cart.total_excl_with_discount_and_promocodes : 0 | currency }}
  </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => {
    return {};
  },
  computed: {
    ...mapState('cart', ['cart', 'loading']),
  },
  methods: {
    showcart: function() {
      window.location = route('cart.index');
    }
  },
};
</script>
